import { FixedPlugin } from "../components/fixed-plugin";
import Footer from "../components/footer";
import Navbar from "../components/navbar";
import {
  AboutUs,
  Commitment,
  Contact,
  Details,
  Founders,
  Home,
  Integration,
  Soluctions,
} from "../sections";
import { useState } from "react";
import { WebsiteContent } from "../utils/WebsiteContent";

const HomePage = () => {
  const [index, setIndex] = useState(0);
  return (
    <div className="lg:w-full w-fit">
      <>
        <Navbar
          NAV_MENU={WebsiteContent[index].NAV_MENU}
          setIndex={setIndex}
          index={index}
        />
        <Home texts={WebsiteContent[index].home} />
        <AboutUs texts={WebsiteContent[index].about} />
        <Integration texts={WebsiteContent[index].integration} />
        <Details texts={WebsiteContent[index].details} />
        <Commitment texts={WebsiteContent[index].commitment} />
        <Founders texts={WebsiteContent[index].founders} />
        <Soluctions texts={WebsiteContent[index].soluctions} />
        <Contact texts={WebsiteContent[index].contact} />
        <Footer
          texts={WebsiteContent[index].footer}
          setIndex={setIndex}
          index={index}
        />
        <FixedPlugin />
      </>
    </div>
  );
};

export default HomePage;
